import { call, put, takeLatest } from 'redux-saga/effects'

import { postProject, putProject, patchProject } from '@galo-monitor/services/apis/galoMonitorApi/resources/project'

import { ProjectActions, ProjectTypes } from './duckProject'

function* saveProject({ project, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(project.id ? putProject : postProject, project)
    yield call(onSuccess)
  } catch (err) {
    yield put(ProjectActions.projectError(err.message))
    yield call(onError, err)
  }
}

function* toggleArchiveProject({ project, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(patchProject, project)
    yield call(onSuccess)
  } catch (err) {
    yield put(ProjectActions.projectError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(ProjectTypes.SAVE_PROJECT, saveProject),
  takeLatest(ProjectTypes.TOGGLE_ARCHIVE_PROJECT, toggleArchiveProject)
]
